module.exports = __webpack_public_path__ + "static/statusquo@2x-23f8ed18cff81f477014692fe5803313.jpg";